/**
 * @file DetailsPanel.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of lead to manage course & country details
 */
import React from "react";
import { Box, Stack, Typography, Skeleton, Divider } from "@mui/material";
import { CourseSelection } from "./CourseSelection";
import { CountrySelection } from "./CountrySelection";
import { LanguageSelection } from "./LanguageSelection";

export const DetailsPanel = ({
  isLoading,
  countryList,
  courseList,
  selectedCountry,
  setSelectedCountry,
  courseCountry,
  setCourseCountry,
  languageList,
  languages,
  selectedLanguage,
  setSelectedLanguage,
  setLanguages
}) => {
  return (
    <Box
      flex={1}
      height="100%"
      borderRadius="12px"
      px="8px"
      py={3}
      bgcolor="#F7F7F7"
      display="flex"
      flexDirection="column"
    >
      <Stack
        pb={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        {isLoading ? (
          <Skeleton variant="rounded" width={140} height={24} />
        ) : (
          <Typography fontWeight={500} fontSize={20} color="#222222">
            Preferences
          </Typography>
        )}
      </Stack>
      <Divider />
      <Stack direction="row" height="100%" display="flex">
        <CountrySelection
          isLoading={isLoading}
          countryList={countryList}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          courseCountry={courseCountry}
          setCourseCountry={setCourseCountry}
        />
        <Divider
          sx={{ mb: 4 }}
          orientation="vertical"
          variant="middle"
          flexItem
        />
        <CourseSelection
          isLoading={isLoading}
          selectedCountry={selectedCountry}
          courses={courseList}
          courseCountry={courseCountry}
          setCourseCountry={setCourseCountry}
        />
        <Divider
          sx={{ mb: 4 }}
          orientation="vertical"
          variant="middle"
          flexItem
        />
        <LanguageSelection
          isLoading={isLoading}
          languageList={languageList}
          languages={languages}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
          setLanguages={setLanguages}
        />
      </Stack>
    </Box>
  );
};
